import { Component, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ICategory, DoodProductModel } from '@core/models/product.model';
import { PRODUCT_STORE_COMPONENT_ACTIONS } from '@store/product/product.action';
import { CategoryKeys } from '@config/keys/category.keys';
import { ProductKeys } from '@config/keys/product.keys';
import { ContentBuilderColorValue } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ProductCategoryColorOverrides } from '@shared/interfaces/product-category-color-overrides.interface';
import { ProductPushV2AtomHoverColors } from '@shared/interfaces/product-hover-colors.interface';
import { ProductCardListAtomComponent } from '../product-card-list-atom/product-card-list-atom.component';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';
import { InterfaceToInputs } from '@shared/utils/types/interface-to-inputs';

@Component({
  selector: 'app-product-category-horizontal-highlight-atom',
  templateUrl: './product-category-horizontal-highlight-atom.component.html',
  imports: [ProductCardListAtomComponent, ContentBuilderColorPipe],
})
export class ProductCategoryHorizontalHighlightAtomComponent implements InterfaceToInputs<
  ProductCategoryColorOverrides,
  { required: true }
> {
  category = input.required<ICategory>();
  products = input<DoodProductModel[] | undefined>();
  isOrderingAllowed = input<boolean>(true);
  categoryNameColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  categoryDescriptionColor = input<ContentBuilderColorValue>({
    value: 'neutral-600',
    type: ColorFieldTypesValues.Palette,
  });
  highlightCategoryNameColor = input<ContentBuilderColorValue>({
    type: ColorFieldTypesValues.Default,
    value: '',
  });
  highlightCategoryBackgroundColor = input<ContentBuilderColorValue>({
    value: 'neutral-600',
    type: ColorFieldTypesValues.Palette,
  });
  productNameColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  productDescriptionColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  productPriceColor = input<ContentBuilderColorValue>({
    value: 'neutral-900',
    type: ColorFieldTypesValues.Palette,
  });
  productImagePlaceholderColor = input<ContentBuilderColorValue>({
    value: 'neutral-50',
    type: ColorFieldTypesValues.Palette,
  });
  productBorderColor = input<ContentBuilderColorValue>({
    value: 'neutral-100',
    type: ColorFieldTypesValues.Palette,
  });
  productBackgroundColor = input<ContentBuilderColorValue>({
    value: '#FFFFFF',
    type: ColorFieldTypesValues.Hex,
  });
  productHoverColors = input<ProductPushV2AtomHoverColors | undefined>();

  private readonly store = inject(Store);
  categoryKeys = CategoryKeys;
  productKeys = ProductKeys;

  onNavigateTo(product: DoodProductModel): void {
    this.store.dispatch(
      PRODUCT_STORE_COMPONENT_ACTIONS.selectProduct({
        productId: product.id,
        productShopId: product.shop_id,
        productOrigin: {
          channel: 'catalog',
          reference: `category_${this.category().id}`,
        },
      }),
    );
  }

  colorOrFallback(color?: ContentBuilderColorValue, fallback?: ContentBuilderColorValue) {
    if (typeof color === 'string') {
      return color || fallback;
    }

    if (color?.type === ColorFieldTypesValues.Default || !color) {
      return fallback;
    }

    return color;
  }
}
